export default __webpack_public_path__ + "static/media/service-6.96ecac90.png";